// extracted by mini-css-extract-plugin
module.exports = {"update":"lastupdate_update__2-5mn"};